import { Component, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { EventService, WindowRef } from '@spartacus/core';
import { BREAKPOINT, BreakpointService, CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { CmsBannerComponent, UserSelectContentTypes } from '../../../core/model';
import { UserSelectContentEvent } from '../../../core/user';
import { MediaService } from '../../../shared';

@Component({
  selector: 'py-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  standalone: false,
})
export class BannerComponent implements OnInit {
  data$: Observable<CmsBannerComponent>;
  noBackgroundImageBanners: string[] = ['banner-content-right', 'banner-content-right-3', 'banner-link'];
  showBlocksBannerText = false;
  bannerId: string;

  get buttonClass(): string {
    return (
      this.elementRef.nativeElement?.className
        ?.split(' ')
        ?.find((name) => name?.includes('cta-'))
        ?.replace('cta-', '') || 'btn-primary'
    );
  }

  get headerLevel(): string {
    const parent: HTMLElement = this.elementRef.nativeElement?.parentElement;
    if (parent?.tagName?.match(/page-slot/i) && parent?.classList?.contains('Banner')) {
      return 'h1';
    }
    return 'h2';
  }

  @HostListener('document:click', ['$event'])
  onLinkItemClick(event) {
    const target = event?.target;

    if (this.windowRef.isBrowser() && target) {
      if (this.elementRef?.nativeElement?.contains(target)) {
        this.eventService.dispatch(new UserSelectContentEvent(target, UserSelectContentTypes.BANNER, this.bannerId));
      }
    }
  }

  constructor(
    public component: CmsComponentData<CmsBannerComponent>,
    public mediaService: MediaService,
    private elementRef: ElementRef,
    protected renderer: Renderer2,
    private breakpointService: BreakpointService,
    private windowRef: WindowRef,
    private eventService: EventService
  ) {}

  ngOnInit(): void {
    this.data$ = this.component.data$.pipe(
      tap((data) => {
        //Banners inside a bannerCollection will inherit classes of the bannerCollection.
        const bannerClasses = data?.styleClasses && typeof data.styleClasses === 'string' ? data.styleClasses : '';

        if (bannerClasses) {
          bannerClasses.split(' ').forEach((bannerClass) => {
            this.renderer.addClass(this.elementRef.nativeElement, bannerClass);
          });
        }

        this.bannerId = data?.uid;
      }),
      map((data) => ({ ...data, content: data?.content?.trim() })),
      switchMap((data) =>
        this.breakpointService
          .isDown(BREAKPOINT.sm)
          .pipe(map((isBelow) => ({ ...data, media: isBelow && data.mediaSmall?.url ? data.mediaSmall : data?.media })))
      )
    );
  }

  hasClass(className: string): boolean {
    return !!this.elementRef.nativeElement?.className?.split(' ').find((name) => name === className);
  }

  /**
   * Returns `_blank` to force opening the link in a new window whenever the
   * `data.external` flag is set to true.
   */
  getTarget(data: CmsBannerComponent): string | null {
    return data.external === 'true' || data.external === true ? '_blank' : null;
  }

  hasBannerBackground(data: CmsBannerComponent): boolean {
    if (!data?.styleClasses?.split) {
      return true;
    }

    return !data.styleClasses
      .split(' ')
      .find((backgroundClass) =>
        this.noBackgroundImageBanners.find((noBackgroundImageBanner) => noBackgroundImageBanner === backgroundClass)
      );
  }
}
